<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h4 class="cardD">Complementa la información</h4>

    <h4 class="cardD">Accionistas</h4>

    <div class="mb-4">
      <label for="">Acciones con valor nominal</label>
      <b-form-checkbox
        v-model="constitutiva.acciones_valor_nominal"
        :disabled="constitutiva.disabledComplementa"
      ></b-form-checkbox>
    </div>

    <label class="leyenda blue-text-important">Edita cada uno de los accionistas para llenar todos los datos necesarios.</label>
    <label class="leyenda blue-text-important">Serás enviado al apartado de comparecientes.</label>

    <div class="row">
      <div class="col-12">
        <label for="">Cuadro Accionario</label>
        <b-table hover :fields="fieldsCuadro" :items="constitutiva.accionistas">
          <!-- <template #cell(capital_variable)="{ item }">
            <b-input v-model="item.capital_variable" type="number"
              :disabled="constitutiva.tiene_capital_variable && constitutiva.disabledComplementa"></b-input>
          </template> -->
          <template #cell(capital_fijo)="{ item }">
            {{ formatCurrency(item.capital_fijo) }}
          </template>
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editCompareciente(item)"
            >
              <b-icon-pencil />
            </b-button>
          </template>
          <template #cell(listo)="{ item }">
            <div v-if="item.persona == 'Persona Moral'">
              <div v-if="item.rfc">
                <div class="circle completado_green" v-if="item.rfc.length === 12">
                  <span class="number"><i class="fa fa-check"></i></span>
                </div>
                <div class="circle completado_yellow" v-else>
                  <span class="number"><i class="fa fa-minus"></i></span>
                </div>
              </div>
              <div v-else>
                <div class="circle completado_yellow">
                  <span class="number"><i class="fa fa-minus"></i></span>
                </div>
              </div>
            </div>
            <div v-else-if="item.persona == 'Persona Física'">
              <div v-if="item.rfc">
                <div class="circle completado_green" v-if="item.rfc.length === 13">
                  <span class="number"><i class="fa fa-check"></i></span>
                </div>
                <div class="circle completado_yellow" v-else>
                  <span class="number"><i class="fa fa-minus"></i></span>
                </div>
              </div>
              <div v-else>
                <div class="circle completado_yellow">
                  <span class="number"><i class="fa fa-minus"></i></span>
                </div>
              </div>
            </div>
          </template>
        </b-table>

        <label for="">¿Tendrá cláusula de admisión de extranjeros?</label>
        <div v-if="constitutiva.capital_extranjero">
          <b-form-checkbox v-model="constitutiva.clausula_extranjeros" disabled></b-form-checkbox>
        </div>
        <div v-else>
          <b-form-checkbox
            v-model="constitutiva.clausula_extranjeros"
            :disabled="constitutiva.disabledComplementa"
          ></b-form-checkbox>
        </div>
      </div>
    </div>

    <h4 class="cardD mt-3">Administradores</h4>
    <label class="leyenda blue-text-important">Agrega el RFC a cada uno de los admnistradores.</label>

    <b-modal no-close-on-backdrop centered ref="administrador-modal" title="" hide-footer id="modalC" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putAdministrador)">
          <ModalOrganosAdministradores :currentAdministrador="currentAdministrador" @submit.prevent :complete="true" />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="vigilancia-modal" title="" hide-footer id="modalV" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putVigilancia)">
          <ModalOrganosVigilancia :currentVigilancia="currentVigilancia" @submit.prevent :complete="true" />
        </form>
      </ValidationObserver>
    </b-modal>

    <div class="row">
      <div class="col-12">
        <label v-if="constitutiva.tipo_societario === 'SA' || constitutiva.tipo_societario === 'SAPI'">Administradores</label>
        <label v-if="constitutiva.tipo_societario === 'S de RL'">Gerentes</label>

        <b-table hover :fields="fieldsCuadroAdmin" :items="constitutiva.administradores">
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editAdministrador(item)"
              :disabled="constitutiva.disabledComplementa"
            >
              <b-icon-pencil />
            </b-button>
          </template>
          <template #cell(listo)="{ item }">
            <div v-if="item.rfc">
              <div class="circle completado_green" v-if="item.rfc.length === 13">
                <span class="number"><i class="fa fa-check"></i></span>
              </div>
              <div class="circle completado_yellow" v-else>
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
            <div v-else>
              <div class="circle completado_yellow">
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <h4 class="cardD mt-3">Vigilancia</h4>
    <label class="leyenda blue-text-important">Agrega el RFC a cada uno de los comisarios.</label>

    <div
      v-if="
        constitutiva.tipo_administracion === 'Consejo de Administración' ||
        constitutiva.tipo_administracion === 'Consejo de Gerentes'
      "
    ></div>

    <div class="row">
      <div class="col md-12">
        <label for="">Comisario u Órgano de Vigilancia</label>
        <div>
          <label class="mb-12 leyenda blue-text-important" v-if="constitutiva.tipo_societario === 'S de RL'">Campo opcional</label>
        </div>

        <b-table hover :fields="fieldsCuadroVigilancia" :items="constitutiva.vigilancia">
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editVigilancia(item)"
              :disabled="constitutiva.disabledComplementa"
            >
              <b-icon-pencil />
            </b-button>
          </template>
          <template #cell(listo)="{ item }">
            <div v-if="item.rfc">
              <div class="circle completado_green" v-if="item.rfc.length === 13">
                <span class="number"><i class="fa fa-check"></i></span>
              </div>
              <div class="circle completado_yellow" v-else>
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
            <div v-else>
              <div class="circle completado_yellow">
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <h4 class="cardD mt-3">Representantes y Apoderados</h4>
    <label class="leyenda blue-text-important">Agrega el RFC a cada uno de los apoderados.</label>

    <b-modal no-close-on-backdrop centered ref="apoderado-modal" title="" hide-footer id="modalC" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putApoderado)">
          <ModalApoderados
            :currentApoderado="currentApoderado"
            @submit.prevent
            :options_facultades="options_facultades"
            :complete="true"
          />
        </form>
      </ValidationObserver>
    </b-modal>

    <div class="row">
      <div class="col-12">
        <label for="">Apoderados</label>
        <b-table hover :fields="fieldsCuadroApoderados" :items="constitutiva.apoderados">
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editApoderado(item)"
              :disabled="constitutiva.disabledComplementa"
            >
              <b-icon-pencil />
            </b-button>
          </template>
          <template #cell(listo)="{ item }">
            <div v-if="item.rfc">
              <div class="circle completado_green" v-if="item.rfc.length === 13">
                <span class="number"><i class="fa fa-check"></i></span>
              </div>
              <div class="circle completado_yellow" v-else>
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
            <div v-else>
              <div class="circle completado_yellow">
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <div class="mt-4">
      <div v-if="constitutiva.disabledComplementa === false">
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="!canValidate">Continuar</b-button>
      </div>
      <div v-else>
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="constitutiva.disabledComplementa">
          Continuar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import ModalOrganosAdministradores from "@/views/clients/procesos/constitucion/infoBase/modales/ModalOrganosAdministradores.vue";
import ModalOrganosVigilancia from "@/views/clients/procesos/constitucion/infoBase/modales/ModalOrganosVigilancia.vue";
import ModalApoderados from "@/views/clients/procesos/constitucion/infoBase/modales/ModalApoderados.vue";

import Storage from "@/utils/storage";
import { formatCurrency } from "@/utils/number-utils";

const storage = new Storage();

export default {
  name: "ComplementaInformacion",

  computed: {
    fieldsCuadro() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "nombreCompleto", label: "Nombre", class: "text-center" },
        // { key: "paterno", label: "Paterno", class: "text-center" },
        // { key: "materno", label: "Materno", class: "text-center" },
        // { key: "email", label: "Email", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "porcentaje", label: "Porcentaje", class: "text-center" },
        { key: "capital_fijo", label: "Capital Fijo", class: "text-center" },
        //{
        //  key: "capital_variable",
        //  label: "Capital Variable",
        //  class: "text-center",
        //  thStyle: { width: '150px' },
        //  tdStyle: { width: '150px' }
        //},
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
    },

    fieldsCuadroAdmin() {
      let fieldsCuadroAdmin = [
        // { key: "index", label: "", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "cargo", label: "Cargo", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
      return fieldsCuadroAdmin;
    },
    fieldsCuadroVigilancia() {
      let fieldsCuadroVigilancia = [
        // { key: "index", label: "", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "cargo", label: "Cargo", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
      return fieldsCuadroVigilancia;
    },
    fieldsCuadroApoderados() {
      let fieldsCuadroApoderados = [
        { key: "index", label: "", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
      return fieldsCuadroApoderados;
    },
  },

  created() {
    this.calcularCapitales();
    this.getFacultades();
    this.clausula();
    this.enableSave();
  },

  watch: {
    "constitutiva.accionistas": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
    "constitutiva.administradores": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
    "constitutiva.vigilancia": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
    "constitutiva.apoderados": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
  },

  components: {
    ModalOrganosAdministradores,
    ModalOrganosVigilancia,
    ModalApoderados,
  },

  props: {
    constitutiva: { type: Object },
    cat_facultades: { type: Array },
  },

  data() {
    return {
      canValidate: false,

      optionsEstados: [
        { text: "Aguascalientes", value: "Aguascalientes" },
        { text: "Baja California", value: "Baja California" },
        { text: "Baja California Sur", value: "Baja California Sur" },
        { text: "Campeche", value: "Campeche" },
        { text: "Chiapas", value: "Chiapas" },
        { text: "Chihuahua", value: "Chihuahua" },
        { text: "Coahuila", value: "Coahuila" },
        { text: "Colima", value: "Colima" },
        { text: "Ciudad de México", value: "Ciudad de México" },
        { text: "Durango", value: "Durango" },
        { text: "Estado de México", value: "Estado de México" },
        { text: "Guanajuato", value: "Guanajuato" },
        { text: "Guerrero", value: "Guerrero" },
        { text: "Hidalgo", value: "Hidalgo" },
        { text: "Jalisco", value: "Jalisco" },
        { text: "Michoacán ", value: "Michoacán " },
        { text: "Morelos", value: "Morelos" },
        { text: "Nayarit", value: "Nayarit" },
        { text: "Nuevo León", value: "Nuevo León" },
        { text: "Oaxaca", value: "Oaxaca" },
        { text: "Puebla", value: "Puebla" },
        { text: "Querétaro", value: "Querétaro" },
        { text: "Quintana Roo", value: "Quintana Roo" },
        { text: "San Luis Potosí", value: "San Luis Potosí" },
        { text: "Sinaloa", value: "Sinaloa" },
        { text: "Sonora", value: "Sonora" },
        { text: "Tabasco", value: "Tabasco" },
        { text: "Tamaulipas", value: "Tamaulipas" },
        { text: "Tlaxcala", value: "Tlaxcala" },
        { text: "Veracruz ", value: "Veracruz " },
        { text: "Yucatán", value: "Yucatán" },
        { text: "Zacatecas", value: "Zacatecas" },
      ],

      loading: false,
      comparecientes: [],
      options_comparecientes: [],
      selectedCompareciente: null,
      currentComparecienteId: null,
      currentCompareciente: null,
      totalPorcentajes: null,

      optionsSaSapi: [
        { text: "Administrador único", value: "Administrador único" },
        { text: "Consejo de Administración", value: "Consejo de Administración" },
      ],
      optionsSrl: [
        { text: "Gerente General", value: "Gerente General" },
        { text: "Consejo de Gerentes", value: "Consejo de Gerentes" },
      ],
      currentAdministrador: null,
      currentAdministradorId: null,
      currentVigilancia: null,
      currentVigilanciaId: null,

      currentApoderado: null,
      currentApoderadoId: null,
      options_facultades: [],

      form: {
        accion: null,

        capital_fijo: null,
        capital_variable: null,
        accionistas: [],
        totalPorcentajesF: null,

        tipo_administracion: null,
        administradores: [],
        presidente_voto: null,
        vigilancia: [],

        apoderados: [],
      },
    };
  },

  methods: {
    formatCurrency,

    enableSave() {
      let count = 0;
      this.constitutiva.accionistas.forEach((item) => {
        if (item.rfc) {
          if (item.persona == "Persona Moral") {
            if (item.rfc.length != 12) {
              count++;
            }
          } else if (item.persona == "Persona Física") {
            if (item.rfc.length != 13) {
              count++;
            }
          }
        } else {
          count++;
        }
      });
      this.constitutiva.administradores.forEach((item) => {
        if (item.rfc) {
          if (item.rfc.length != 13) {
            count++;
          }
        } else {
          count++;
        }
      });
      this.constitutiva.vigilancia.forEach((item) => {
        if (item.rfc) {
          if (item.rfc.length != 13) {
            count++;
          }
        } else {
          count++;
        }
      });
      this.constitutiva.apoderados.forEach((item) => {
        if (item.rfc) {
          if (item.rfc.length != 13) {
            count++;
          }
        } else {
          count++;
        }
      });
      if (count === 0) {
        this.canValidate = true;
      } else {
        this.canValidate = false;
      }
    },

    clausula() {
      if (this.constitutiva.capital_extranjero === 1 || this.constitutiva.capital_extranjero === true) {
        this.constitutiva.clausula_extranjeros = true;
      } else if (this.constitutiva.clausula_extranjeros === true || this.constitutiva.clausula_extranjeros === 1) {
        this.constitutiva.clausula_extranjeros = true;
      } else {
        this.constitutiva.clausula_extranjeros = false;
      }
    },

    async getFacultades() {
      this.loading = true;

      try {
        this.cat_facultades.forEach((element) => {
          const obj = {
            text: element.facultad,
            value: element.facultad,
          };
          this.options_facultades.push(obj);
        });

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    calcularCapitales() {
      let totalPorcentajes = 0;
      for (let i = 0; i < this.constitutiva.accionistas.length; i++) {
        let capital_fijo = (this.constitutiva.accionistas[i].porcentaje * this.constitutiva.capital_fijo) / 100;

        this.constitutiva.accionistas[i].capital_fijo = capital_fijo;

        let capital_variable = (this.constitutiva.accionistas[i].porcentaje * this.constitutiva.capital_variable) / 100;
        this.constitutiva.accionistas[i].capital_variable = capital_variable;

        totalPorcentajes = totalPorcentajes + parseFloat(this.constitutiva.accionistas[i].porcentaje);

        var a = Object.assign({}, this.constitutiva.accionistas[i]);
        this.constitutiva.accionistas.splice([i], 1, a);
      }
      // this.totalPorcentajes = totalPorcentajes;
    },

    editCompareciente(item) {
      // this.$router.push(
      //   `/dashboard/comparecientes/editcomparecientes/${item.id}`
      // );
      let accion = "nuevo";
      if (this.constitutiva.accion === "edit") {
        accion = "edit";
      }
      this.$router.push({
        path: `/dashboard/comparecientes/editcomparecientes/${item.id}`,
        query: {
          proceso: 1,
          procesoAccion: "addconstitucion",
          procesoId: this.constitutiva.id,
          accion: accion,
        },
      });
      //mandar con alguna bandera para que regrese al consti_id y node completa_info
    },

    editAdministrador(item) {
      this.$refs["administrador-modal"].show();
      this.currentAdministrador = item;
    },

    putAdministrador() {
      if (!this.currentAdministrador.id) {
        let id = this.constitutiva.administradores.length + 1;
        this.currentAdministrador.id = id;
        var a = Object.assign({}, this.currentAdministrador);
        this.constitutiva.administradores.push(a);
      } else {
        let index = this.constitutiva.administradores.findIndex(
          // (o) => o.id === this.currentAdministradorId
          (o) => o.id === this.currentAdministrador.id,
        );
        var a = Object.assign({}, this.currentAdministrador);
        // this.constitutiva.administradores[index] = a;
        this.constitutiva.administradores.splice([index], 1, a);
      }
      this.$refs["administrador-modal"].hide();
    },

    async editVigilancia(item) {
      this.$refs["vigilancia-modal"].show();
      this.currentVigilancia = item;
      // const valid = await this.$refs.provider.errors(this.currentVigilancia);
    },

    putVigilancia() {
      if (!this.currentVigilancia.id) {
        let id = this.constitutiva.vigilancia.length + 1;
        this.currentVigilancia.id = id;
        var a = Object.assign({}, this.currentVigilancia);
        this.constitutiva.vigilancia.push(a);
      } else {
        let index = this.constitutiva.vigilancia.findIndex((o) => o.id === this.currentVigilancia.id);
        var a = Object.assign({}, this.currentVigilancia);
        // this.constitutiva.vigilancia[index] = a;
        this.constitutiva.vigilancia.splice([index], 1, a);
      }
      this.$refs["vigilancia-modal"].hide();
    },

    editApoderado(item) {
      this.$refs["apoderado-modal"].show();
      this.currentApoderado = item;
    },

    putApoderado() {
      if (!this.currentApoderado.id) {
        let id = this.constitutiva.apoderados.length + 1;
        this.currentApoderado.id = id;
        var a = Object.assign({}, this.currentApoderado);
        this.constitutiva.apoderados.push(a);
      } else {
        let index = this.constitutiva.apoderados.findIndex((o) => o.id === this.currentApoderado.id);
        var a = Object.assign({}, this.currentApoderado);
        // this.constitutiva.apoderados[index] = a;
        this.constitutiva.apoderados.splice([index], 1, a);
      }
      this.$refs["apoderado-modal"].hide();
    },
  },
};
</script>

<style scoped>
.completado_green {
  background-color: #9acd32 !important;
}
</style>
